import { memo, type Dispatch, type SetStateAction } from 'react';

import { useFlag } from '../../services/launchDarkly';
import type { Game } from '../../stores/game/types';

import { GameCard } from './GameCard';
import styles from './GamesCarousel.module.scss';

export const CarouselBlock = memo(function CarouselBlock(props: {
  games: Set<Game>;
  onboardingRow: boolean;
  // Over the whole row, not this block's chunk — see `GameCardProps.rowHasJackpot`.
  rowHasJackpot: boolean;
  rowName: string;
  setReferenceElement: Dispatch<SetStateAction<HTMLElement | null>>;
}) {
  const games = Array.from(props.games);
  const gameLabelFF = useFlag('game_labels_feat', true);

  return (
    <div className={styles.gamesBlock}>
      {games.map((game, gameIdx) => {
        return (
          <GameCard
            key={`${game.identifier}:${game.masterCasinoGameId}`}
            carousel
            animated={false}
            game={game}
            gameLabelFF={gameLabelFF}
            onboarding={props.onboardingRow && gameIdx === 1}
            rowHasJackpot={props.rowHasJackpot}
            rowName={props.rowName}
            tooltipRef={props.onboardingRow && gameIdx === 1 ? props.setReferenceElement : null}
          />
        );
      })}
    </div>
  );
});
